import { defineComponent as _defineComponent } from 'vue'
import { computed, watch, ref } from 'vue';
import { defineMessages } from '@/lib/i18n';
import { i18n } from '@/plugins/vue-i18n';
import sharedMessages from '@/lib/shared-messages';
import { useVerification } from '@/composables/useVerification';
import VerifyForm from '@/views/pages/login/VerifyForm.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VerifyDialog',
  props: {
  isOpen: {
    type: Boolean,
    required: true,
  },
  tfaPhoneNumber: {
    type: String,
    required: true,
  },
  availableTfaMethods: {
    type: Array,
    default: () => ['totp', 'phone_code'],
  },
},
  emits: ["verificationSuccess", "cancel"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'verificationSuccess'): void;
  (e: 'cancel'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;

const $t = i18n.t.bind(i18n);

const m = defineMessages({
  enterVerificationCodeToProceed: '認証コードを入力してください',
});



const isValidForm = ref<boolean>(false);



const {
  mode,
  verificationToken,
  isInitializing,
  isVerifying,
  errorAlert,
  waitForCooldown,
  resendingCode,
  resendRequired,
  codeResent,
  cooldownTimeLeft,
  tfaEmail,
  showAlternatives,
  canUseBackupCodes,
  verifyCode,
  resendCode,
  switchMode,
  updateVerificationToken,
  resetForm,
  initializeVerification,
} = useVerification({
  isDialog: true,
  availableMethods: props.availableTfaMethods,
  onSuccess: () => {
    emits('verificationSuccess');
  },
});

const handleCancelAction = () => {
  resetForm();
  emits('cancel');
};

const visible = computed(() => props.isOpen);

// Initialize when dialog opens
watch(
  () => props.isOpen,
  (isOpen) => {
    if (isOpen) {
      resetForm();
      initializeVerification();
    }
  },
  { immediate: true }
);

return { __sfc: true,$t, m, props, isValidForm, emits, mode, verificationToken, isInitializing, isVerifying, errorAlert, waitForCooldown, resendingCode, resendRequired, codeResent, cooldownTimeLeft, tfaEmail, showAlternatives, canUseBackupCodes, verifyCode, resendCode, switchMode, updateVerificationToken, resetForm, initializeVerification, handleCancelAction, visible, sharedMessages, VerifyForm }
}

})